import { ShieldCheck, BadgeCheck } from "lucide-react";

const STORE_IMG = "https://customer-assets.emergentagent.com/job_serrurerie-atelier/artifacts/1oxvfxt2_secretaire%20serrurier.jpeg";
const VAN_IMG = "https://customer-assets.emergentagent.com/job_serrurerie-atelier/artifacts/yxk6l04r_e498bd56-735d-47f8-9526-69da3334e3aa.jpeg";
const BRANDS_IMG = "https://customer-assets.emergentagent.com/job_serrurerie-atelier/artifacts/z5lc5i3l_serrurier%20marques%20serrures.jpeg";

const BusinessShowcase = () => {
    return (
        <section className="bg-[#FAFAFA] border-y border-black/10" data-testid="business-showcase">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
                <div className="max-w-3xl">
                    <div className="text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500 mb-4">
                        ◉ Atelier Beauchamp en images
                    </div>
                    <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[0.95]">
                        Un accueil humain,<br /><span className="text-[#E63946]">un vrai artisan.</span>
                    </h2>
                    <p className="mt-5 text-base sm:text-lg text-zinc-600 leading-relaxed">
                        Atelier Beauchamp, c'est une vraie personne au bout du fil et un véhicule équipé de stocks importants pour effectuer vos réparations sur place et sans délai.
                        Vous identifiez immédiatement notre intervention — pas de mauvaise surprise, pas de prestataire douteux.
                    </p>
                </div>

                {/* Photos */}
                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
                    <figure className="relative bg-white border border-black/10 group overflow-hidden" data-testid="showcase-store">
                        <img
                            src={STORE_IMG}
                            alt="Accueil téléphonique Atelier Beauchamp — une vraie personne répond 24/7"
                            className="w-full h-[280px] sm:h-[360px] lg:h-[420px] object-cover transition-transform duration-500 group-hover:scale-[1.02]"
                            loading="lazy"
                        />
                        <figcaption className="absolute top-0 left-0 bg-[#0A0A0A] text-white px-3 py-2 flex items-center gap-2">
                            <ShieldCheck className="h-3.5 w-3.5 text-[#E63946]" strokeWidth={2.6} />
                            <span className="text-[10px] uppercase tracking-[0.18em] font-semibold">Accueil téléphonique</span>
                        </figcaption>
                        <figcaption className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-black/10 px-4 py-3">
                            <div className="font-display font-bold text-sm uppercase tracking-tight">Un interlocuteur dédié · 24/7</div>
                            <div className="text-xs text-zinc-600 mt-0.5">Réponse immédiate · Devis au téléphone</div>
                        </figcaption>
                    </figure>

                    <figure className="relative bg-white border border-black/10 group overflow-hidden" data-testid="showcase-van">
                        <img
                            src={VAN_IMG}
                            alt="Véhicule d'intervention Atelier Beauchamp — 06 49 50 18 43"
                            className="w-full h-[280px] sm:h-[360px] lg:h-[420px] object-cover transition-transform duration-500 group-hover:scale-[1.02]"
                            loading="lazy"
                        />
                        <figcaption className="absolute top-0 left-0 bg-[#0A0A0A] text-white px-3 py-2 flex items-center gap-2">
                            <BadgeCheck className="h-3.5 w-3.5 text-[#E63946]" strokeWidth={2.6} />
                            <span className="text-[10px] uppercase tracking-[0.18em] font-semibold">Véhicule d'intervention</span>
                        </figcaption>
                        <figcaption className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-black/10 px-4 py-3">
                            <div className="font-display font-bold text-sm uppercase tracking-tight">Dépannage serrurier express</div>
                            <div className="text-xs text-zinc-600 mt-0.5">06 49 50 18 43 — Installation · Dépannage</div>
                        </figcaption>
                    </figure>
                </div>

                {/* Brands */}
                <div className="mt-16 lg:mt-20" data-testid="showcase-brands">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-8">
                        <div className="lg:col-span-7">
                            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500 mb-4">
                                ◉ Marques que nous posons
                            </div>
                            <h3 className="font-display font-bold uppercase text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-[0.95]">
                                Toutes les grandes marques<br />de serrurerie.
                            </h3>
                        </div>
                        <p className="lg:col-span-5 text-sm sm:text-base text-zinc-600 leading-relaxed">
                            ABUS, Bricard, City, Dierre, DOM, Fichet, FTH Thirard, ISEO, JPM, Kaba, Medeco,
                            Mottura, Mul-T-Lock, Picard, Pollux, Reelax, Ronis, Vachette, Viro… nous installons
                            et dépannons les principales marques de serrures et cylindres certifiés.
                        </p>
                    </div>

                    <div className="bg-white border border-black/10 p-4 sm:p-6 lg:p-8">
                        <img
                            src={BRANDS_IMG}
                            alt="Marques de serrures installées et dépannées : ABUS, Bricard, City, Dierre, DOM, Fichet, FTH Thirard, ISEO, JPM, Kaba, Medeco, Mottura, Mul-T-Lock, Picard, Pollux, Reelax, Ronis, Vachette, Viro"
                            className="w-full h-auto object-contain"
                            loading="lazy"
                        />
                    </div>
                    <div className="mt-4 text-xs uppercase tracking-[0.18em] text-zinc-500 font-semibold">
                        + autres marques sur demande · Toutes serrures haute sécurité A2P
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BusinessShowcase;
